module.exports = "/assets/site/images/user_menu_icon.png?8105ecaa33bd97b3913dfe03796a307d";